import {NetworkOutreachDetails, NetworkOutreachDetailsProps} from "./NetworkOutreachDetails";
import { OutreachExportType } from "../export/enumerations";

const ServiceLocation: React.FC<React.PropsWithChildren<NetworkOutreachDetailsProps>> = (props:NetworkOutreachDetailsProps) => {
  return (
    <NetworkOutreachDetails {...props} name="Service Location" exportType={ OutreachExportType.ServiceLocation } />
  )
}

export default ServiceLocation;